import * as React from 'react'
import { useContext, useState } from 'react';
import { getDirectionsUrl } from '../../services/maps-api';
import { getCelSchoolProfile } from '../../services/prek-school-api';
import BannerMap from '../info/banner-map';
import { AppContext } from '../school-search-app';
import { getAvailabilityColor, formatPhone } from "../../utility/api-utilities";

function PrekProfile(props) {
    /**
    const [school, setSchool] = useState(null)
    React.useEffect(() => {
        getCelSchoolProfile(props.schoolId).then(result => {
            console.log('profile result', result);
            setSchool(result);
        });
    }, []);
    **/
    const school = props.school;

    const appContext = useContext(AppContext)

    const schoolInformation = [
        { label: 'School Type', value: 'Community Based' },
        { label: 'Age Ranges Served', value: school.AgeRangesServed },
        { label: 'Address', value: school.Address },
        { label: 'Phone', value: formatPhone(school.Phone) },
        { label: 'Fax', value: school.Fax },
    ];

    const hoursInformation = [
        { label: 'Duration', value: [school.IsFullYear ? 'Year-round' : null, school.IsSchoolYear ? 'School-year' : null].filter(x => x != null).join(', ') },
        { label: 'School Day', value: [school.FullDayProgram == 'Yes' ? 'Full Day' : null, school.PartDayProgram == 'Yes' ? 'Half Day' : null].filter(x => x != null).join(', ') },
        { label: 'School Hours', value: school.SchoolStartTime && school.SchoolEndTime ? `${school.SchoolStartTime} - ${school.SchoolEndTime} ` : '' }
    ];

    const programInformation = [
        { label: 'Accepts CCAP', value: school.AcceptsCCAP == 'Yes' },
        { label: 'Head Start', value: school.HeadStartProgram == 'Yes' },
        { label: 'Early Head Start', value: school.EarlyHeadStartProgram == 'Yes' },
        { label: 'Home Visits', value: school.HomeVisits == 'Yes' },
    ];

    const socials: ({ type: string, link: string })[] = [
        { link: school.socialMediaDescriptor1, type: school.socialMediaUrl1 },
        { link: school.socialMediaDescriptor2, type: school.socialMediaUrl2 },
        { link: school.socialMediaDescriptor3, type: school.socialMediaUrl3 },
        { link: school.socialMediaDescriptor4, type: school.socialMediaUrl4 },
    ].filter(s => s.type);


    const socialLink = (info) => {
        let icon = "fa-info";
        switch (info.type) {
            case 'Twitter':
                icon = "fa-twitter";
                break;
            case 'Facebook':
                icon = "fa-facebook";
                break;
            case 'Instagram':
                icon = "fa-instagram";
                break;
        }
        return <a className={`fa ${icon}`} href={info.link} target="_blank">&nbsp;</a>
    }

    const basicInfo = (info) => {
        return info.value &&
            <div key={info.label} className="info">
                <span className="label">{info.label ? `${info.label}: `: ``} </span>
                <span className="value">{info.value}</span>
            </div>
    }

    const checkButton = (program) => {
        if (program.DisplayButton == 'Yes') {
            const date = new Date(program.ApplicationDeadline);
            if (date < (new Date())) {
                return <a className="btn" target="_blank" href="https://cps.schoolmint.com">Apply Now</a>
            }
        }
        return program.ApplicationDeadline
    }

    const programBlock = (program) => <div key={program.programName} className="table-scrolling-wrapper">
        <table className="prek-programs">
            <thead>
                <tr>
                    <th>Program Name</th>
                    <th>Ages</th>
                    <th>Availability</th>
                    <th>Application Opens</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>{program.ProgramName}</td>
                    <td>{program.AgesServed}</td>
                    <td>
                        <span className={`circle ${getAvailabilityColor(school.Availability)}`}></span> {school.Availability}
                    </td>
                    <td><strong>{checkButton(program)}</strong></td>
                </tr>
            </tbody>
        </table>
    </div>
    const qualityRating = (rating: string) => {
        return <div className="qualityRatingBlock" >
            <span className={`qualityRating-label image rounded qualityRating-${rating.toLowerCase()}`}>
                <img src={`/Static-Adage/img/search/qualityRating/GoCPS_Excel_Rating_Icon_${rating}.svg`} />
            </span>
            <span className="qualityRating-title">{rating}</span>
        </div>
    }
    const validPrograms = programInformation.filter(p => p.value);
    const validContacts = school.Contacts.filter(c => c.ContactName);
  
    return (school ? <div className="bs-shim cel-profile">
        {<div className="padded-page-header">
            <BannerMap school={school} height="225px" />
        </div>}
        <div className="main-overview container-fluid">
            <div className="row main-school-info">
                <div className="col-sm-9">
                    <div className="content">
                        <h2>{school.SchoolLongName}</h2>
                        <div dangerouslySetInnerHTML={{ __html: school.Description }}></div>
                    </div>
                </div>
                <div className="col-sm-3 prek-profile-buttons">
                    {school.Website && <a className="btn" target="_blank" href={school.Website} >View Website</a>}
                    <a className="btn" target="_blank" href={getDirectionsUrl(`${school.Address}, ${school.City} ${school.PostalCode}`)}>Directions</a>
                    {socials.length > 0 &&
                        <div className="socials-block">
                            {socials.map(social => socialLink(social))}
                        </div>
                    }
                </div>
            </div>
            <div className="row basics">
                <div className="col-sm-6">
                    <div className="info-block">
                        <h3>School Information</h3>
                        {schoolInformation.map(info => basicInfo(info))}
                    </div>
                    <div className="info-block">
                        { validContacts.length > 0 && <>
                            <h3>Faculty</h3>
                            {validContacts.map(contact => basicInfo({ label: contact.ContactTitle, value: contact.ContactName }))}
                        </>}
                    </div>
                </div>
                <div className="col-sm-6">
                    <div className="info-block">
                        <h3>Duration and Hours</h3>
                        {hoursInformation.map(info => basicInfo(info))}
                    </div>
                    <div className="info-block">
                        {validPrograms.length > 0 && <>
                            <h3>Program Information</h3>
                            {validPrograms.map(info => <div key={info.label} className="info">
                                <span className="value">{info.label}</span>
                            </div>)}
                        </>}
                    </div>
                </div>
            </div>
            <div className="row prek-overview-block programs availability">
                <div className="col">
                    {school.Programs.map(program => programBlock(program))}
                </div>
            </div>
            <div className="row">
                <div className="col">
                    {school.Accreditation &&
                        <div className="prek-overview-block accreditation-block">
                            <h3>Accreditation</h3>
                            <div className="accreditation-list">{school.Accreditation}</div>
                            <div><strong>What does "Accreditation" mean?</strong></div>
                            <p>Programs that receive national accreditation have demonstrated quality in areas such as
                                teaching, curriculum, learning assessments, health, community relationships, physical
                                environment, and management.</p>
                        </div>
                    }
                    {school.QualityRating &&
                        <div className="prek-overview-block accreditation-block">
                            <h3>Excelerate Quality Rating</h3>
                            {qualityRating(school.QualityRating)}
                      
                            <div><strong>What does "Quality Rating" mean?</strong></div>
                            <p>Quality Rating indicates the quality of a site based on the Excelerate Illinois system.
                                More information can be found at <a href="https://www.excelerateillinois.com/" target="_blank">ExcelerateIllinois.com.</a></p>
                        </div>
                    }
                    {school.Languages &&
                        <div className="prek-overview-block accreditation-block">
                            <h3>Languages</h3>
                            <div>{school.Languages}</div>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div> : <></>);
}

export default PrekProfile;